module.exports = __webpack_public_path__ + "img/3.eeac7c81.png";